import { render, staticRenderFns } from "./QyLogin.vue?vue&type=template&id=55af717e&scoped=true"
import script from "./QyLogin.vue?vue&type=script&lang=js"
export * from "./QyLogin.vue?vue&type=script&lang=js"
import style0 from "./QyLogin.vue?vue&type=style&index=0&id=55af717e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af717e",
  null
  
)

export default component.exports